module.exports = __webpack_public_path__ + "img/qrCode.1e180109.svg";